<template>
  <div :class="['box box-primary', notes.length === 0 ? 'collapsed-box' : '']">
    <div class="box-header with-border">
      <i class="fa fa-phone"></i>
      <h3 class="box-title"> Notizen / Telefonate</h3>
      <div class="box-tools pull-right">
        <span data-toggle="tooltip" :title="notes.length" class="badge bg-success">{{notes.length}}</span>
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i :class="[notes.length === 0 ? 'fa fa-plus' : 'fa fa-minus']"></i>
        </button>
      </div>
    </div>
    <div class="box-body chat" id="chat-box">
      <div class="item" v-if="notes.length === 0">
        <p>
          <small>Es sind noch keine Telefonate / Notizen zu diesem Vorgang hinterlegt.</small>
        </p>
      </div>
      <div v-else class="item" v-for="note in notes">
        <template v-if="edit[note.id]">
          <div class="input-group">
            <textarea class="form-control" placeholder="Notizeintrag..." v-model="note.original_message"></textarea>
          </div>
        </template>
        <template v-else>
          <div class="col-xs-12">
            <p class="message">
              <a href="#" class="name">
                <span class="pull-right">{{note.date | orderDate}} <i class="fa fa-clock-o mr-5 ml-5"></i>{{note.date | orderDate(true)}}</span>{{note.author}}</a>
              <br/>
              <small><template v-for="line in note.message">{{line}}<br/></template></small>
            </p>
          </div>
        </template>
      </div>
    </div>
    <div class="box-footer">
      <label>Notiz verfassen</label>
      <div class="input-group">
        <textarea class="form-control" placeholder="Notizeintrag..." v-model="noteBody"></textarea>
        <div class="input-group-btn">
          <button @click="sendData('POST')" type="button" class="btn btn-success"><i class="fa fa-save mr-5"></i>{{'submit' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['id', 'notes'],
  data () {
    return {
      edit: [],
      noteBody: ''
    }
  },
  methods: {
    sendData (method, data = {message: this.noteBody}) {
      let extra = ''
      if (method === 'PUT') {
        extra = `/${data.id}`
        data.note = data.original_message
      }
      API({method: method, url: `clickAndCollect/${this.id}`, data: data})
        .then(response => {
          data.date = moment()
          data.message = data.message.split('\n')
          this.notes.push(data)
        })
    },
    editNote (noteId) {
      this.edit[noteId] = true
      this.edit = [...this.edit]
    }
  },
  mounted () {
  },
  watch: {
  	notes () {
    }
  }
}
</script>
<style scoped>
  .chat .item > button {
    width: 40px;
    height: 40px;
    border: 2px solid transparent;
    border-radius: 50%;
  }
  .form-control{
    height: 35px !important;
  }
  .italic {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/ReservationNotes.vue